import { Box, Dialog, DialogContent, DialogTitle, Divider, RadioGroup, FormControlLabel, Radio, IconButton, Stack, TextField, Typography, useMediaQuery, DialogActions } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useChargeWalletByAdminMutation } from "src/_api/mapitShipApi";
import { Clear } from "@mui/icons-material";
import { ConfirmDialog, TextFieldNumber } from "src/_modules/common";
import { useEffect, useState } from "react";
import { LoadingButton } from "@mui/lab";
import { runJoiValidate } from "src/_utils";
import { WALLET_TRANSACRION_SCHEMA } from "../ValidationSchemas";

export default function AdminMerchantWalletDialog({
    open,
    onClose,
    merchantId,
    balance
}) {
    const { t } = useTranslation()
    const fullScreen = useMediaQuery(theme => theme.breakpoints.down('md'));

    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

    //======= Charge Wallet =========
    const [chargeWalletByAdmin, {
        isLoading,
        error,
        isSuccess,
        reset
    }] = useChargeWalletByAdminMutation()

    const [transaction, setTransaction] = useState({
        amount: 0,
        description: "",
        type: "CREDIT",
        shipmentId: ""
    })

    const handleChange = ({ target: { name, value } }) => {
        // if (name === "amount" && transaction?.type === "DEBIT" && Number(value) > balance) return
        if (name == "type") {
            setTransaction(prev => ({
                ...prev,
                amount: 0
            }))
        }
        setTransaction(prev => ({
            ...prev,
            [name]: value
        }))
    }

    const [validationErrors, setValidationErrors] = useState(null)

    const onSubmit = () => {
        setValidationErrors(null)
        const payload = { merchantId, ...transaction }
        const errors = runJoiValidate(WALLET_TRANSACRION_SCHEMA, payload)
        if (!!errors) {
            setValidationErrors(errors)
            return
        }
        setOpenConfirmDialog(true)
    }

    const adminConfirmHandler = async () => {
        try {

            let payload = { merchantId, ...transaction }
            payload.amount = Number(payload.amount)
            await chargeWalletByAdmin(payload).unwrap()
            setTimeout(() => {
                setOpenConfirmDialog(false)
                setTransaction({
                    amount: 0,
                    description: "",
                    type: "CREDIT",
                     shipmentId: ""
                })
                onClose(true)
            }, 2500);
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        if (!openConfirmDialog) {
            setTransaction({
                amount: 0,
                description: "",
                type: "CREDIT",
                shipmentId: ""
            })
            reset()
        }
    }, [openConfirmDialog])


    return (
        <>
            <ConfirmDialog
                open={openConfirmDialog}
                onClose={() => setOpenConfirmDialog(false)}
                confirmFn={adminConfirmHandler}
                loading={isLoading}
                isSuccess={isSuccess}
                error={error}
                title="Warning"
                disabled={isSuccess}
                content={t(transaction?.type === "DEBIT" ? "adminDebitWalletAmountAlert" : "adminCreditWalletAmountAlert", { amount: transaction?.amount })}
            />
            <Dialog
                open={open}
                fullWidth
                maxWidth="md"
                fullScreen={fullScreen}
                onClose={(e) => e.preventDefault()}
            >
                <DialogTitle sx={{ display: "flex", alignItems: "center" }}>
                    {t("Credit/Debit Wallet")}
                    <IconButton sx={{ ml: "auto" }} onClick={onClose} color="primary">
                        <Clear />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Stack spacing={2}>
                        <RadioGroup
                            row
                            name="type"
                            value={transaction?.type}
                            onChange={handleChange}
                        >
                            <FormControlLabel
                                value="CREDIT"
                                control={<Radio color="primary" />}
                                label={t("Charge Wallet")}
                            />
                            <FormControlLabel
                                value="DEBIT"
                                control={<Radio color="error" />}
                                label={t("Debit Wallet")}
                                componentsProps={{ typography: { color: "error" } }}
                            />
                        </RadioGroup>
                        <TextFieldNumber
                            name="amount"
                            label={t("Amount")}
                            value={transaction?.amount}
                            variant="outlined"
                            required
                            size="small"
                            onChange={handleChange}
                            error={!!validationErrors?.amount}
                            helperText={validationErrors?.amount ?? ''}
                        />
                        <TextField
                            multiline
                            rows={3}
                            required
                            name="description"
                            value={transaction?.description}
                            onChange={handleChange}
                            label={t("Note")}
                            variant="outlined"
                            size="small"
                            error={!!validationErrors?.description}
                            helperText={validationErrors?.description ?? ''}
                        />
                        <TextField
                            name="shipmentId"
                            label={t("Shipment Number")}
                            value={transaction?.shipmentId}
                            variant="outlined"
                            size="small"
                            onChange={handleChange}
                            error={!!validationErrors?.shipmentId}
                            helperText={validationErrors?.shipmentId ?? ''}
                        />
                        <Typography variant="h6" color={transaction?.type === "DEBIT" ? "error" : "primary"} sx={{ visibility: transaction?.amount > 0 ? "visible" : "hidden" }}>
                            {t(transaction?.type === "DEBIT" ? "adminDebitWalletAmountAlert" : "adminCreditWalletAmountAlert", { amount: transaction?.amount })}
                        </Typography>
                        
                    </Stack>
                </DialogContent>
                <Divider />
                <DialogActions>
                    {isSuccess && <Typography color="success.main">{t("Done successfully")}</Typography>}
                    {!!error && <Typography color="error">{error}</Typography>}
                    <Box mr="auto" />
                    <LoadingButton
                        color={transaction?.type === "DEBIT" ? "error" : "primary"}
                        variant="contained"
                        onClick={onSubmit}
                        sx={{ textTransform: "none" }}
                        loading={isLoading}
                        disabled={isSuccess}
                    >
                        {t("Confirm")}
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    )
}
